import { useState } from "react";

import { TextTestID } from "@/constants/TestID";
import ModalTitleHeader from "@/ui/composed/modal/ModalTitleHeader";
import { Avatar, FAIconName, Text } from "@/ui/core";
import { HStack } from "@/ui/layout";
import { tokens } from "@/ui/theme/tamagui.config";
import { joinTestIDs } from "@/utils/string.util";

const { borderColor, borderWidth } = tokens;

interface ChannelHeaderProps {
  avatarUserId?: string;
  channelName: string;
  channelUrl: string;
  isGroupChannel: boolean;
  members: BaseUserAvatarProps[];
  onDetailsPress: () => void;
  onDismiss: () => void;
}

interface ActionComponentProps extends ViewWithTestID {
  avatarUserId?: string;
  channelName: string;
  memberCount: number;
  onPress: () => void;
}
const ActionComponent = ({
  avatarUserId,
  channelName,
  memberCount,
  onPress,
  testID,
}: ActionComponentProps) => {
  const [isHighlighted, setIsHighlighted] = useState<boolean>(false);

  return (
    <HStack
      alignItems="center"
      borderColor={isHighlighted ? borderColor.selected : borderColor.primary}
      borderRadius={8}
      borderWidth={borderWidth.primary}
      gap={12}
      onPress={onPress}
      onPressIn={() => setIsHighlighted(true)}
      onPressOut={() => setIsHighlighted(false)}
      paddingHorizontal={10}
      paddingVertical={8}
    >
      <Avatar
        size="xxs"
        testID={testID}
        userId={avatarUserId}
        userName={channelName}
        userType="provider"
      />
      <Text testID={joinTestIDs(testID, "count")} variant="caption">
        {memberCount}
      </Text>
    </HStack>
  );
};

const ChannelHeader = ({
  avatarUserId,
  channelName,
  channelUrl,
  isGroupChannel,
  members,
  onDetailsPress,
  onDismiss,
}: ChannelHeaderProps) => {
  const baseTestID = joinTestIDs(channelUrl, TextTestID.Header);

  return (
    <ModalTitleHeader
      actionComponents={
        <ActionComponent
          avatarUserId={avatarUserId}
          channelName={channelName}
          memberCount={members.length}
          onPress={onDetailsPress}
          testID={baseTestID}
        />
      }
      icon={isGroupChannel ? FAIconName.UserGroupSolid : undefined}
      modalAccessibilityTitle={channelName}
      onDismiss={onDismiss}
      testID={baseTestID}
      title={channelName}
    />
  );
};

export type { ChannelHeaderProps };
export default ChannelHeader;
